"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardViewExecConfig = exports.DashboardViewExecConfigProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DashboardViewExecConfigContext = react_1.default.createContext(undefined);
DashboardViewExecConfigContext.displayName = "DashboardViewConfigContext";
/**
 * @internal
 */
exports.DashboardViewExecConfigProvider = function (_a) {
    var children = _a.children, execConfig = _a.execConfig;
    return (react_1.default.createElement(DashboardViewExecConfigContext.Provider, { value: execConfig }, children));
};
/**
 * @internal
 */
exports.useDashboardViewExecConfig = function () {
    return react_1.default.useContext(DashboardViewExecConfigContext);
};
//# sourceMappingURL=DashboardViewExecConfigProvider.js.map